export const formatFileSize = (bytes: number) => {
  const kb = bytes / 1024;
  const mb = kb / 1024;
  const kb_ = `${kb.toFixed(1)} KB`;
  const mb_ = `${mb.toFixed(1)} MB`;
  // prettier-ignore
  return (mb > 1) ? `${mb_}` : ((kb > 1) ? `${kb_}` : `${bytes} B`);
};
